import { render, staticRenderFns } from "./DivNaviKeySettings.vue?vue&type=template&id=4b65c6ee"
import script from "./DivNaviKeySettings.vue?vue&type=script&lang=js"
export * from "./DivNaviKeySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports